import ProfileRadiobox from './profile-radiobox';

export default ProfileRadiobox;